<template>
  <div class="ZhDetails" v-if="detailObj">
    <div class="ZhDetails_infos">
      <div class="ZhDetails_infos_left">
        <div class="ZhDetails_infos_left_cover">
          <img
            v-if="detailObj.coverUrl && detailObj.coverUrl !== '--'"
            :src="detailObj.coverUrl"
            alt=""
          />
        </div>
        <div class="ZhDetails_infos_left_info">
          <!-- 国内 -->
          <div v-if="isZh">
            <p>期刊等级：<span v-text="detailObj.journalLevel"></span></p>
            <p>出版周期：<span v-text="detailObj.publishPeriod"></span></p>
            <p>ISSN：<span v-text="detailObj.issn"></span></p>
            <p>CN：<span v-text="detailObj.cn"></span></p>
            <p>开本：<span v-text="detailObj.bookSize"></span></p>
            <p>邮发代号：<span v-text="detailObj.postCode"></span></p>
          </div>
          <!-- 国际 -->
          <div v-else>
            <p>出版周期：<span v-text="detailObj.publishPeriod"></span></p>
            <p>ISSN：<span v-text="detailObj.issn"></span></p>
            <p>E-ISSN：<span v-text="detailObj.eissn"></span></p>
          </div>
        </div>
      </div>
      <div class="ZhDetails_infos_right">
        <header class="ZhDetails_infos_right_header">
          <div>
            <div
              class="ZhDetails_infos_right_header_titleZh"
              v-html="detailObj.name"
            ></div>
            <div
              class="ZhDetails_infos_right_header_titleEn"
              v-html="detailObj.enName"
            ></div>
          </div>
          <ul>
            <template v-for="(item, index) in includedData">
              <li :key="`inc-${index}-${item.abbrName || index}`" v-if="item.abbrName">
                <img src="@/assets/img/jp.png" alt="" />
                <span>{{ item.abbrName }}</span>
              </li>
            </template>
            <template v-for="(item, index) in journalHonor">
              <li :key="`hon-${index}-${item.honorAbbr || index}`" v-if="item.honorAbbr">
                <img src="@/assets/img/jp.png" alt="" />
                <span>{{ item.honorAbbr }}</span>
              </li>
            </template>
          </ul>
        </header>
        <!-- 国内 -->
        <el-row :gutter="30" v-if="isZh" class="ZhDetails_infos_right_info">
          <el-col :span="8" class="ZhDetails_infos_right_info_item">
            <div class="ZhDetails_infos_right_info_item_title">基本信息</div>
            <ul>
              <li>
                <span>曾用名：</span><span v-text="detailObj.usedName"></span>
              </li>
              <li>
                <span>主管单位：</span
                ><span v-text="detailObj.supervisoryUnit"></span>
              </li>
              <li>
                <span>主办单位：</span><span v-text="detailObj.org"></span>
              </li>
              <li>
                <span>主编：</span><span v-text="detailObj.chiefEditor"></span>
              </li>
              <li>
                <span>出版地：</span
                ><span v-text="detailObj.publishRegion"></span>
              </li>
              <li>
                <span>语种：</span><span v-text="detailObj.language"></span>
              </li>
              <li>
                <span>创刊时间：</span
                ><span v-text="detailObj.journalCreateTime"></span>
              </li>

            </ul>
          </el-col>
          <el-col :span="8" class="ZhDetails_infos_right_info_item">
            <div class="ZhDetails_infos_right_info_item_title">出版信息</div>
            <ul>
              <li>
                <span>中信所分类：</span><span v-text="detailObj.zxsCat"></span>
              </li>
              <li>
                <span>专辑名称：</span
                ><span v-text="detailObj.subjectName"></span>
              </li>
              <li>
                <span>专题名称：</span
                ><span v-text="detailObj.topicName"></span>
              </li>
              <li>
                <span>出版文献量：</span
                ><span v-text="detailObj.zwArticleCount"></span>
              </li>
              <li>
                <span>总下载次数：</span
                ><span v-text="detailObj.downloadCount"></span>
              </li>
              <li>
                <span>总被引次数：</span
                ><span v-text="detailObj.quoteCount"></span>
              </li>
              <li>
                <span>审稿周期：</span
                ><span v-text="detailObj.reviewCycle"></span>
              </li>

            </ul>
          </el-col>
          <el-col :span="8" class="ZhDetails_infos_right_info_item">
            <div class="ZhDetails_infos_right_info_item_title">评价信息</div>
            <ul>
              <li>
                <span>影响因子（核心）：</span
                ><span v-text="detailObj.influence4"></span>
              </li>
              <li>
                <span>影响因子（扩展）：</span
                ><span v-text="detailObj.influence2"></span>
              </li>
              <li>
                <span>复合影响因子：</span
                ><span v-text="detailObj.compoundInfluenceFactor"></span>
              </li>
              <li>
                <span>综合影响因子：</span
                ><span v-text="detailObj.comprehensiveInfluenceFactor"></span>
              </li>
              <li>
                <span>影响因子（JCR）：</span
                ><span v-text="detailObj.impactFactor"></span>
              </li>
              <li>
                <span>h-index：</span>
                <span v-text="detailObj.hIndex"></span>
              </li>
            </ul>
          </el-col>
        </el-row>
        <!-- 国际 -->
        <el-row :gutter="30" v-else class="ZhDetails_infos_right_info">
          <el-col :span="8" class="ZhDetails_infos_right_info_item">
            <div class="ZhDetails_infos_right_info_item_title">基本信息</div>
            <ul>
              <li>
                <span>出版商：</span><span v-text="detailObj.publisher"></span>
              </li>
              <li>
                <span>出版地：</span
                ><span v-text="detailObj.publishRegion"></span>
              </li>
              <li>
                <span>语种：</span><span v-text="detailObj.language"></span>
              </li>
              <li>
                <span>创刊时间：</span
                ><span v-text="detailObj.journalCreateTime"></span>
              </li>
              <li>
                <span>中信所分类：</span><span v-text="detailObj.zxsCat"></span>
              </li>
            </ul>
          </el-col>
          <el-col :span="8" class="ZhDetails_infos_right_info_item">
            <div class="ZhDetails_infos_right_info_item_title">出版信息</div>
            <ul>
              <li>
                <span>研究方向：</span
                ><span v-text="detailObj.researchField"></span>
              </li>
              <li>
                <span>是否OA：</span
                ><span
                  v-text="detailObj.oaLiteratureType === 'true' ? '是' : '否'"
                ></span>
              </li>
              <li>
                <span>Gold OA文章占比：</span
                ><span v-text="detailObj.goldOaArticlePercentage"></span>
              </li>
              <li>
                <span>研究类文章占比：</span
                ><span v-text="detailObj.researchArticlePercentage"></span>
              </li>
              <li>
                <span>年发文量：</span
                ><span v-text="detailObj.publicationVolume"></span>
              </li>
              <li>
                <span>审稿周期：</span
                ><span v-text="detailObj.reviewCycle"></span>
              </li>
              <li>
                <span>Time to first decision：</span
                ><span v-text="detailObj.submissionToFirstDecision"></span>
              </li>
              <li>
                <span>Review time：</span
                ><span v-text="detailObj.reviewTime"></span>
              </li>
              <li>
                <span>Submission to acceptance：</span
                ><span v-text="detailObj.submissionToAcceptance"></span>
              </li>
              <li>
                <span>Acceptance to publicatlon：</span
                ><span v-text="detailObj.acceptanceToPublication"></span>
              </li>
            </ul>
          </el-col>
          <el-col :span="8" class="ZhDetails_infos_right_info_item">
            <div class="ZhDetails_infos_right_info_item_title">评价信息</div>
            <ul>
              <li>
                <span>中科院分区：</span
                ><span v-text="detailObj.casRank"></span>
              </li>
              <li>
                <span>JCR分区：</span><span v-text="detailObj.jcrRank"></span>
              </li>
              <li>
                <span>CiteScore分区：</span
                ><span v-text="detailObj.citeScoreRank"></span>
              </li>
              <li>
                <span>是否预警：</span
                ><span v-text="detailObj.journalAlert"></span>
              </li>
              <li>
                <span>IF：</span><span v-text="detailObj.impactFactor"></span>
              </li>
              <li>
                <span>JCI期刊引文指标：</span
                ><span v-text="detailObj.jciCitationIndicator"></span>
              </li>
              <li>
                <span>CiteScore：</span
                ><span v-text="detailObj.citeScore"></span>
              </li>
              <li>
                <span>h-index：</span>
                <span v-text="detailObj.hIndex"></span>
              </li>
            </ul>
          </el-col>
        </el-row>
        <div class="ZhDetails_infos_right_item">
          <h3>期刊收录：</h3>
          <p v-if="includedData && includedData.length">
            <span v-for="(item, index) in includedData" :key="index">{{
              item.name
            }}</span>
          </p>
          <p v-else>--</p>
        </div>
        <div class="ZhDetails_infos_right_item">
          <h3>期刊荣誉：</h3>
          <p v-if="journalHonor && journalHonor.length">
            <span v-for="(item, index) in journalHonor" :key="index">{{
              item.honorName
            }}</span>
          </p>
          <p v-else>--</p>
        </div>
      </div>
    </div>
    <div class="ZhDetails_content">
      <!-- tab -->
      <ul class="ZhDetails_content_tabs">
        <li
          class="ZhDetails_content_tabs_item"
          v-for="(item, index) in tabOptions"
          :key="index"
          @click="tabClick(index)"
          :class="{ active: activeName === item.value }"
        >
          <span>{{ item.label }}</span>
        </li>
      </ul>
      <div class="ZhDetails_content_columns">
        <ul>
          <li
            v-for="(item, index) in columns"
            :key="index"
            :class="{ active: activeIndex === index }"
            @click="activeIndex = index"
          >
            {{ item }}
          </li>
        </ul>
        <div>
          <p
            v-show="activeIndex === 0"
            v-html="detailObj.journalIntroduction"
          ></p>
          <p v-show="activeIndex === 1">--</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GetMagDetail,
  GetincludedDatabase,
  GetjournalHonor
} from "@/api/detail";
export default {
  name: "ZhDetails",
  props: {
    details: {
      type: Object,
      default: () => {}
    },
    isZh: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    details: {
      handler(nv) {
        if (nv) {
          this.detailObj = nv;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      chooseId: "",
      detailObj: null,
      journalHonor: [],
      includedData: [],
      activeName: "bkxx",
      columns: ["期刊简介", "主要栏目"],
      activeIndex: 0
    };
  },
  computed: {
    ...mapGetters({
      magId: "magId"
    }),
    tabOptions() {
      let arr = [];
      if (this.isZh) {
        arr = [
          { label: "本刊信息", value: "bkxx" },
          { label: "统计评价", value: "tjpj" },
          { label: "引用引证", value: "yzyy" }
        ];
      } else {
        arr = [
          { label: "本刊信息", value: "bkxx" },
          { label: "CiteScore指标", value: "citeScore" },
          { label: "JCR分区", value: "jcr" },
          { label: "中科院分区", value: "zkyfq" },
          { label: "统计评价", value: "tjpjen" },
          { label: "引用引证", value: "yzyy" }
        ];
      }
      return arr;
    }
  },
  created() {
    this.chooseId = this.$route.query.searchId;
    // this.getMagDetail();
    this.getincludedDatabase();
    this.getjournalHonor();
  },
  methods: {
    // 点击按钮滚动到目标位置
    scrollToTarget(refName) {
      const targetElement = this.$refs[refName];
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" }); // 平滑滚动
      }
    },
    tabClick(index) {
      console.log(index, "index", this.tabOptions[index].value);
      this.$emit("scrollToTarget", this.tabOptions[index].value);
    },
    // 期刊详情查询
    getMagDetail() {
      const params = {
        id: this.chooseId
      };
      GetMagDetail(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          for (let key in data) {
            data[key] =
              data[key] === "" || data[key] === null || data[key] === undefined
                ? "--"
                : data[key];
          }
          this.$set(this, "detailObj", data);
          console.log(this.detailObj, "详情信息");
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 期刊收录：
    getincludedDatabase() {
      const params = {
        magId: this.magId
      };
      GetincludedDatabase(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.includedData = res.data.data;
        }
      });
    },
    // 期刊荣誉
    getjournalHonor() {
      const params = {
        magId: this.magId
      };
      GetjournalHonor(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.journalHonor = res.data.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ZhDetails {
  margin: 0 auto;
  text-align: left;
  color: #000;
  &_infos {
    display: flex;
    padding: 50px 50px 0px 50px;
    background: #f9f9f9;
    font-size: 12px;
    &_left {
      margin-right: 60px;
      &_cover {
        width: 180px;
        min-height: 250px;
        background: #f2f2f2;
        margin-bottom: 20px;
        img {
          width: 100%;
        }
      }
      &_info {
        line-height: 24px;
        span {
          color: #666;
        }
      }
    }
    &_right {
      flex: 1;
      &_header {
        display: flex;
        margin-bottom: 20px;
        &_titleZh {
          font-size: 24px;
          font-weight: bolder;
          margin-bottom: 10px;
          line-height: 1;
        }
        &_titleEn {
          font-size: 14px;
          color: #666;
        }
        ul {
          margin-left: 20px;
          display: flex;
          align-items: center;
          height: 20px;
          flex-wrap: wrap;
          li {
            display: flex;
            align-items: center;
            margin-right: 10px;
            img {
              width: 20px;
              height: 20px;
              margin-right: 5px;
            }
          }
        }
      }
      &_info {
        margin-bottom: 20px;
        &_item {
          &_title {
            font-weight: bolder;
            color: #666;
            background: #f2f2f2;
            height: 40px;
            line-height: 40px;
            margin-bottom: 10px;
            font-size: 14px;
          }
          ul {
            li {
              line-height: 24px;
              > span:nth-child(2) {
                color: #666;
              }
            }
          }
        }
      }
      &_item {
        margin-bottom: 20px;
        h3 {
          margin-bottom: 5px;
        }
        p {
          span {
            margin-right: 10px;
            color: #666;
          }
          line-height: 24px;
        }
      }
    }
  }
  &_content {
    padding: 20px 50px;
    &_tabs {
      display: flex;
      border-bottom: 4px solid #f2f2f2;
      margin-bottom: 30px;
      &_item {
        padding: 10px;
        font-size: 20px;
        margin-right: 70px;
        cursor: pointer;
        font-weight: bolder;
        margin-bottom: -4px;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          color: #027dbb;
          border-bottom: 4px solid #027dbb;
        }
        &.active {
          color: #027dbb;
          border-bottom: 4px solid #027dbb;
        }
      }
    }
    /deep/ .el-tabs__item {
      font-size: 18px;
      font-weight: bolder;
      padding: 0 50px;
    }
    /deep/ .el-tabs__item.is-active {
      color: #027dbb;
    }
    /deep/ .el-tabs__active-bar {
      background-color: #027dbb;
    }
    &_columns {
      display: flex;
      ul {
        margin-right: 40px;
        li {
          width: 100px;
          height: 40px;
          text-align: center;
          font-size: 16px;
          line-height: 40px;
          margin-bottom: 10px;
          cursor: pointer;
          font-weight: 500;
          &.active {
            color: #027dbb;
            background: #f2f2f2;
            font-weight: bolder;
          }
        }
      }
    }
  }
}
</style>
